import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamZHCN() {
  return (
    <div className={styles['declaration']}>
      <h1>Compliance Statement for the Training and Examination of Field Force Members</h1>

      <p>
        To continuously enhance the service quality of third-party promoters on the front line, Xiaomi International Department Training Team (hereinafter referred to as “we” or “our company”) provides training courses and accompanying knowledge reinforcement examinations for the third-party promoters (hereinafter referred to as “trainees”) designated by outsourcing service providers. The aim of the training and examination is to optimize course content and consolidate learning outcomes, and does not constitute any form of labor relationship or actual management behavior. The following is the statement regarding the training and examination:
      </p>

      <ol>
        <li>
          <strong>Nature of the Training and Examination</strong><br/>
          All training courses and examinations are conducted for the purpose of knowledge sharing, aims at helping trainees systematically understand product information and service standards etc. Examination results only reflect the trainees’ grasp of the training content and shall not serve as a basis for performance evaluation. We have no authority and will not interfere with the outsourcing service providers’ performance assessments, salary distribution, or other labor relationship matters regarding the trainees.
        </li>
        <li>
          <strong>Clarification of Legal Relationship</strong><br/>
          The employer-employee relationship between trainees and their respective outsourcing service providers remains unaffected by this training and examination program. There is no employer-employee relationship between our company and the trainees, nor does this knowledge-sharing training and examination program establish any de facto employment relationship with the trainees.
        </li>
        <li>
          <strong>Use of Examination Results</strong><br/>
          Examination results shall only be used for the following purposes:
          <ol type="1">
            <li>Serving as a reference for our company’s internal course optimization and improvement;</li>
            <li>Provided to outsourcing service providers as proof of trainees’ professional competence, subject to the independent judgment and willingness of the outsourcing service providers;</li>
            <li>Examination results will not be made public or disclosed to any third party.</li>
          </ol>
        </li>
      </ol>

      <p>
        This statement shall take effect from the date of publication. Participation in the training and examination program constitutes the trainees’ acknowledgment and acceptance of this statement. Our company reserves the final right of interpretation and reasonable amendment of this statement.
      </p>

      <div className={styles["footer"]}>
        Xiaomi International Department Training Team<br/>
        Date: {getLocalizedTime('en-US')}
      </div>
    </div>
  );
}